import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import STATE_FORMATS from "../constants/state-formats";
export default function getAddress(_x, _x2) {
  return _getAddress.apply(this, arguments);
}
function _getAddress() {
  _getAddress = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(cep, stateFormat) {
    var _STATE_FORMATS$uf;
    var safeStateFormat, cleanCEP, apiRoute, data, logradouro, uf, bairro, localidade, state;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          safeStateFormat = stateFormat || "br";
          cleanCEP = cep.split("-").join("");
          apiRoute = "https://viacep.com.br/ws/" + cleanCEP + "/json/";
          _context.next = 5;
          return fetch(apiRoute).then(function (data) {
            return data.json();
          });
        case 5:
          data = _context.sent;
          logradouro = data.logradouro, uf = data.uf, bairro = data.bairro, localidade = data.localidade;
          state = STATE_FORMATS === null || STATE_FORMATS === void 0 ? void 0 : (_STATE_FORMATS$uf = STATE_FORMATS[uf]) === null || _STATE_FORMATS$uf === void 0 ? void 0 : _STATE_FORMATS$uf[safeStateFormat];
          return _context.abrupt("return", {
            logradouro: logradouro,
            uf: state,
            bairro: bairro,
            localidade: localidade
          });
        case 9:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _getAddress.apply(this, arguments);
}